import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";

const ITEMS = [
    { planKey: 'account_summary',    minPlan: 'Professional', title: 'Business Summary',    subtitle: "Portfolio health — active loans, today's collection, outstanding", icon: 'fas fa-tachometer-alt',     color: '#ffc107', path: '/accounts/summary'    },
    { planKey: 'account_collection', minPlan: 'Professional', title: 'EMI Collection',      subtitle: 'Date-wise receipts, payment modes, daily & monthly totals',       icon: 'fas fa-money-bill-wave',    color: '#28a745', path: '/accounts/collection' },
    { planKey: 'account_aging',      minPlan: 'Professional', title: 'Outstanding & Aging', subtitle: 'Overdue EMIs grouped by severity, fine & penalty tracking',       icon: 'fas fa-exclamation-circle', color: '#dc3545', path: '/accounts/aging'      },
    { planKey: 'account_ledger',     minPlan: 'Business',     title: 'Customer Ledger',     subtitle: 'Full payment history per loan — running balance, dues',           icon: 'fas fa-search',             color: '#17a2b8', path: '/accounts/ledger'     },
    { planKey: 'account_pl',         minPlan: 'Business',     title: 'Profit & Loss',       subtitle: 'EMI income, penalty, late fine — revenue per period',             icon: 'fas fa-chart-line',         color: '#6610f2', path: '/accounts/pl'         },
];

export default function Accounts() {
    const navigate = useNavigate();
    const { isPlanAllowed, planName } = useContext(AuthContext);

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">
                                <i className="fas fa-wallet text-primary mr-2"></i>Accounts
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                <li className="breadcrumb-item active">Accounts</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    {planName && (
                        <div className="alert alert-info py-2 mb-3">
                            <i className="fas fa-crown mr-1"></i>
                            Current Plan: <strong>{planName}</strong>
                        </div>
                    )}
                    <div className="row">
                        {ITEMS.map(item => {
                            const allowed = isPlanAllowed(item.planKey);
                            return (
                                <div key={item.planKey} className="col-md-6 mb-4">
                                    <div
                                        className={`card elevation-2 h-100 ${!allowed ? 'border-secondary' : ''}`}
                                        style={{
                                            cursor: allowed ? 'pointer' : 'default',
                                            borderLeft: `4px solid ${allowed ? item.color : '#adb5bd'}`,
                                            transition: 'transform 0.2s',
                                            opacity: allowed ? 1 : 0.7,
                                        }}
                                        onClick={() => { if (allowed) navigate(item.path); }}
                                        onMouseEnter={e => { if (allowed) e.currentTarget.style.transform = 'translateY(-4px)'; }}
                                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                    >
                                        <div className="card-body d-flex align-items-center">
                                            <div
                                                className="mr-3"
                                                style={{ width: 52, height: 52, borderRadius: 12, background: (allowed ? item.color : '#adb5bd') + '22', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                                            >
                                                <i className={allowed ? item.icon : 'fas fa-lock'} style={{ color: allowed ? item.color : '#adb5bd', fontSize: 22 }}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h5 className="mb-0 font-weight-bold" style={{ color: allowed ? '' : '#6c757d' }}>{item.title}</h5>
                                                <small className="text-muted">{item.subtitle}</small>
                                                {!allowed && (
                                                    <div className="mt-1">
                                                        <span className="badge badge-secondary" style={{ fontSize: '11px' }}>
                                                            <i className="fas fa-crown mr-1"></i>Requires {item.minPlan} Plan
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {allowed
                                                ? <i className="fas fa-chevron-right text-muted ml-2"></i>
                                                : <i className="fas fa-lock text-muted ml-2"></i>
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}
